import constants from '../qti/Constants';
import settingsReader from '../store/readHelpers/SettingsReader';

// Checks if an identifier is a drawing response identifier.
export default function isDrawingResponseIdentifier(identifier) {
    return typeof identifier === 'string' && identifier.startsWith('DRAWING-RESPONSE');
}

// Checks if drawing is enabled for preloading purposes.
export function isDrawingEnabledForPreloading(question) {
    if (!settingsReader.isCandidateDrawingOptionEnabled()) {
        return false;
    }

    if (question?.responseModels?.some(model => model.type === constants.interactionType.DRAWING_INTERACTION)) {
        return true;
    }

    if (question?.itemBody?.includes('<drawingInteraction')) {
        return true;
    }

    return false;
}

// Determines if an offline data value should be cleared when serializing item results.
export function shouldClearOfflineDataValue(identifier, includeOfflineData) {
    if (includeOfflineData) {
        return false;
    }
    if (typeof identifier !== 'string') {
        return false;
    }
    return identifier.endsWith('_drawingBase64') || identifier.endsWith('_jsonData') || identifier.endsWith('_pendingSync');
}
